import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DocumentPolicy, DocumentPolicyStatus } from '../../../../../../../models/document-template';

/**
 * A component containing a form for creating and editing document policies.
 *
 * This does not contain logic for actually saving the policies - separate
 * create and edit components handle that, both of which contain an instance of
 * this component.
 */
@Component({
  selector: 'app-document-policy-form',
  templateUrl: './document-policy-form.component.html',
  styleUrls: ['./document-policy-form.component.css']
})
export class DocumentPolicyFormComponent {

  @Input()
  documentPolicy: DocumentPolicy;

  @Input()
  documentPolicyErrors: any;

  @Output()
  documentPolicyChange = new EventEmitter<DocumentPolicy>();

  public DocumentPolicyStatus = DocumentPolicyStatus;

  constructor() {}

}
